import { createSlice } from "@reduxjs/toolkit";

const initialServicesState = {
    filterResult: null,
}

const servicesSlice = createSlice({
    name: 'services',
    initialState: initialServicesState,
    reducers: {
        setFilterResult(state, data) {
            state.filterResult = data.payload
        },
    }
})

export const servicesActions = servicesSlice.actions

export default servicesSlice.reducer